/**
 * Google Fonts on demand. A font is fetched the first time something on the board uses it;
 * nothing loads until then. Requests go to fonts.googleapis.com / fonts.gstatic.com.
 */

export const GOOGLE_FONTS = [
  'Inter',
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Poppins',
  'Nunito',
  'Raleway',
  'Work Sans',
  'DM Sans',
  'Source Sans 3',
  'Playfair Display',
  'Merriweather',
  'Lora',
  'EB Garamond',
  'Cormorant Garamond',
  'Oswald',
  'Bebas Neue',
  'Anton',
  'Archivo Black',
  'Space Grotesk',
  'Space Mono',
  'IBM Plex Sans',
  'IBM Plex Mono',
  'JetBrains Mono',
  'Fira Code',
  'Caveat',
  'Kalam',
  'Permanent Marker',
  'Shadows Into Light',
  'Pacifico',
  'Press Start 2P',
  'VT323',
  'Silkscreen',
] as const;

const loaded = new Set<string>();

/** Injects the stylesheet for a family once. Safe to call during render. */
export function ensureFont(name: string | null | undefined): void {
  if (!name || loaded.has(name) || typeof document === 'undefined') return;
  loaded.add(name);
  const family = encodeURIComponent(name).replace(/%20/g, '+');
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${family}:ital,wght@0,400;0,700;1,400;1,700&display=swap`;
  document.head.appendChild(link);
}

/** CSS font-family value for a Google font (or undefined for the UI default). */
export function fontFamilyCss(name: string | null | undefined): string | undefined {
  if (!name) return undefined;
  ensureFont(name);
  return `"${name}", var(--font-ui)`;
}

/** Recovers the family name from a CSS font-family value produced by fontFamilyCss. */
export function fontNameFromCss(css: string | null | undefined): string | null {
  if (!css) return null;
  const m = /^"([^"]+)"/.exec(css.trim());
  return m ? m[1]! : css.split(',')[0]!.trim().replace(/^['"]|['"]$/g, '') || null;
}
